import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { categoryAPI } from '../services/api';
import STATIC_CATEGORIES from '../assets/categories';

const CategoryContext = createContext();

export const useCategories = () => {
  const context = useContext(CategoryContext);
  if (!context) {
    throw new Error('useCategories must be used within a CategoryProvider');
  }
  return context;
};

/**
 * Backend kategori/alt kategori kayıtlarını, uygulamanın her yerinde kullanılan
 * { id, label, icon, subcategories: [{ id, label }] } şekline çevirir.
 * `id` alanı backend'deki `value` sütunudur — ürünler ve URL filtreleri bu
 * değerle eşleşiyor, sayısal PK ile değil.
 */
const toMenuTree = (apiCategories) =>
  (apiCategories || [])
    .filter((cat) => cat.isActive !== false)
    .map((cat) => ({
      id: cat.value,
      label: cat.label,
      icon: cat.icon || '',
      description: cat.description || '',
      categoryId: cat.id,
      subcategories: (cat.subcategories || [])
        .filter((sub) => sub.isActive !== false)
        .map((sub) => ({ id: sub.value, label: sub.label, subcategoryId: sub.id })),
    }));

export const CategoryProvider = ({ children }) => {
  const [categories, setCategories] = useState(STATIC_CATEGORIES);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const loadCategories = useCallback(async () => {
    try {
      setError(null);
      const response = await categoryAPI.getActiveCategories();
      const tree = toMenuTree(response.data);
      // Backend boşsa statik liste görünürde kalsın — menü hiçbir zaman boş olmasın
      setCategories(tree.length > 0 ? tree : STATIC_CATEGORIES);
    } catch (err) {
      console.error('Kategoriler yüklenirken hata oluştu:', err);
      setError(err);
      setCategories(STATIC_CATEGORIES);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadCategories();
  }, [loadCategories]);

  return (
    <CategoryContext.Provider value={{ categories, loading, error, refresh: loadCategories }}>
      {children}
    </CategoryContext.Provider>
  );
};

export default CategoryContext;
